<template>
      <div class="container-fluid pt-2" v-if="mpesaConfig">
        <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
            <div class="text-center">
                <h1 class="text-center"><i class="bi bi-receipt"></i></h1>
        <p>To view your Mpesa transactions here, you need to configure Mpesa <a v-if="userDetails.roles[0].name==='Admin'" href="/settings/payments"> keys in settings</a></p>
       <p><small>Only proceed with this if you are confident in the process; otherwise, <a :href='"https://api.whatsapp.com/send/?phone=254725445898&text=Hello%20Team%20Dukakit,%20I%20need%20assistance%20on%20Mpesa%20Integration,%20c-id=" + userDetails.company_id'>contact us on WhatsApp for assistance.</a></small></p> 
            </div>
   
    </div>
      </div>
    <div class="container-fluid pt-2" v-else>
      <div  class="row">
        <div class="col-md-6 col-sm-8">
          <div class="text-left py-3">
            <h3 class="text-weight-900">Payment Transactions</h3>
          </div>
        </div>
        <div class="col-md-6 col-sm-4">
          <div class="text-right py-3">
            <a @click="getTransactions()" class="btn btn-outline-secondary"><i class="bi bi-arrow-clockwise"></i> Refresh</a>
          </div>
        </div>
     
      </div>
      <div class="row py-1">
            <div class="col-md-4 col-sm-12 py-1">
                <form>
                    <div class="input-group w-100 my-1">
                        <input type="text" class="form-control" v-model="searchItem" placeholder="Search Transaction">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="submit">
                                        <i class="fa fa-search"></i>
                                    </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-4 col-sm-12 py-1">
           <div v-if="userDetails.roles[0].name==='Admin'" class="text-left">
            <p>Received - {{ convertCurrencyToShillings(totalAmount) }}</p>
            <hr class="m-0"/>
            <p>Balance - {{ convertCurrencyToShillings(accountDetails.balance) }}</p>
            <hr class="m-0"/>
            <p>Notifications Number - {{ accountDetails.msisdn_to_receive_notifs }} <a v-b-modal="'change_mpesa_notif_number'" class="text-primary" href="#">Change</a></p>
            <hr class="m-0"/>
           
            <p></p>
           </div>
            </div>

            <div class="col-md-4 col-sm-12 py-2">
            
                <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker pb-2">
                            <template #input="picker" style="width: 100% !important;">
                                                        <p v-if="picker.startDate !==null && picker.endDate !==null">{{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                                        <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
                            </template>
                                            </date-range-picker>
            </div>
        </div>
     
      <div style="margin-bottom: 5em;">
        <div class="table-responsive">
          <b-table sort-icon-left striped hover :items="filterTransactions" :fields="fields">
            <template #cell(created_at)="row">
              {{ formatDate(row.item.created_at,'hh:mm A DD-MM-YYYY ')}}
            </template>
            <template #cell(amount)="row">
              {{ row.item.amount }}
              <!-- {{convertCurrencyToShillings(row.value.amount)}} -->
            </template>
          </b-table>
          
       
        </div>

      </div>
      <b-modal id="change_mpesa_notif_number" hide-footer>
   
        <div class="d-block text-center">
          <h5>Update number to receive mpesa Notifications</h5>
          <hr/>
          <form @submit.prevent="changeMpesaNumber">
            <input class="form-control" v-model="newMsisdn" placeholder="Enter number"  required/>
            <div class="form-group">
              <button class="btn btn-primary">Submit</button>
            </div>
          </form>
        </div>
  
      </b-modal>
    </div>
    <!-- change_mpesa_notif_number -->
   
  
  </template>
  
  <script>
  import axios from 'axios';
  import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker"; 
  import {mapGetters} from 'vuex'
  
  export default {
    components: {
            DateRangePicker
        },
    data() {
      return {
        transactions: {},
        fields: [
          {
            key: 'trans_id',
            sortable: true,
            label:'Code'
          },
          {
            key: 'first_name',
            sortable: true,
            label:'Name'
          },
          {
            key: 'msisdn',
            sortable: true,
            label:'Phone Number'
          },
          {
            key: 'amount',
            sortable: true,
            label:'Amount'
          },
          {
            key: 'created_at',
            sortable: true,
            label:'Date'
          }
        ],
        dateRange: {
                    startDate: null,
                    endDate: null,
                },
                autoApply: true,
                append_to_body: true,
                datepicker_opens: 'right',
                ranges: false,
                searchItem:'',
                mpesaConfig:false,
                totalAmount:0,
                accountDetails:{},
                newMsisdn:'',
        
       
        
        }
      },
   
    mounted() {
      this.getTransactions();
    },
    computed: {
        ...mapGetters(['userDetails']),
      filterTransactions() {
        return Object.values(this.transactions).filter(item => {
          return item.trans_id && item.trans_id.toLowerCase().includes(this.searchItem.toLowerCase());
        });
      }
    },
    watch: {
            dateRange: {
                deep: true,
                handler(after, before) {
                    if (after.startDate && after.endDate) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const startDateString = after.startDate.toISOString().split('T')[0]; // Convert to ISO format without time
                        const endDateString = after.endDate.toISOString().split('T')[0]; // Convert to ISO format without time

                        urlParams.set('start-date', startDateString);
                        urlParams.set('end-date', endDateString);

                        window.history.replaceState(null, null, '?' + urlParams.toString());
                     }
                    this.getTransactions()
                }
               
            }
        },
    methods: {
      async getTransactions() {
        const urlParams = new URLSearchParams(window.location.search);
         await axios.get('/api/payment-transactions',{
            params:{
                    startdate: urlParams.get('start-date'),
                    enddate: urlParams.get('end-date'),
                    
                   
                 }}).then(response=>{
                    if(response.status === 200 && response.data !=='Mpesa not configured')
                    {
                        this.transactions = response.data.transactions;
                        this.totalAmount = response.data.totalAmount;
                        this.accountDetails = response.data.account;
                    }
                    else
                    {
                        this.mpesaConfig = true
                    }
                      
         }).catch (error=>{})
        
      },
      formatDate(date, format) {
                return moment(date).format(format);
            },
      async changeMpesaNumber() 
      {
          await axios.post('/api/change-mpesa-notification',{
            msisdn: this.newMsisdn
          }).then(
            results=>{
              if(results.status === 200)
            {
              window.location.reload()
            }
            }
          ).catch(e=>{
            this.$toasts.push({
                            'type':"error",
                            "message":"There was an error"
                        })
          })
      },
      
    }
  }
  </script>
  
<style>
.list-search-item {
  margin: 0.5em 0 0.5em 0;
  padding: 0;
}
small{
    font-size: 11px !important;
}
#customdropzone{
    
   
    min-width: 320px;
    min-height: 180px;
  
  }
  

</style>